<div [class]="getContainerClasses()">
  <app-navigation-link
    [codeText]="displayMode === 'both' ? displayCode : ''"
    [nameText]="displayMode === 'both' ? displayName : ''"
    [text]="displayMode !== 'both' ? displayText : ''"
    [isNavigable]="isNavigable"
    [navigationConfig]="navigationConfig"
    [icon]="icon"
    [iconPosition]="iconPosition"
    [showIcon]="showIcon"
    [showText]="showText"
    [interactionMode]="interactionMode"
    [tooltipText]="tooltipText"
    [customClass]="customClass"
    (navigate)="handleNavigation($event)">
  </app-navigation-link>
</div>
